/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import {Redirect} from 'react-router-dom';
import { Button, Label, FormGroup, Col, Tooltip } from 'reactstrap';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { SaveLicenseRequest, UploadLicenseFile, GetLicenseInformation, GetLicenseCustomerInformation, GetServerID,GetTenantWorkOrderLicenseInfo} from '../../../../../action/Administration/administrationAction';
import {getInstanceType, UpdateCloudLicenseCache} from '../../../../../action/Administration/license';
import { getAllResources } from '../../../../../action/cultureAction';
import InactiveWindow from '../../../../Logout/InActive';
import { Modal } from 'reactstrap';
import classnames from 'classnames';
import Idle from 'react-idle';
import '../../../../../Assets/EnsembleStyles/Dashboard/managedashboard.css';
import ViewPanelLicensing from '../Licensing/ViewPanelLicensing';
import UserNotAuthorized from '../../UserNotAuthorized';
import { AppRolePermission } from '../../../../../action/authenticateUser';

let Website="http://www.basregistration.trane.com/Registration/ControlsLicensing.htm";
class ManageLicense extends Component {
    async componentWillMount(){
        // const l_Response = this.props.GetLicenseInformation();
        // await Promise.all([l_Response]);
        const PermissionactionResponse = this.props.AppRolePermission(5,10);
        PermissionactionResponse.then((result) => {
            if(this.props.ApplicationPermission != null && this.props.ApplicationPermission){
                this.setState({HasFullAppPermission:true});
            }else{
                this.setState({HasFullAppPermission:false});
            }
        })
        this.setState({HasLicenseInfo:false});
        const actionResponse = this.props.GetLicenseInformation();
            actionResponse.then((result) => {
                this.setState({HasLicenseInfo:true});
            })
        const actionResponse2 = this.props.getInstanceType();
            actionResponse2.then((result) => {
               this.setState({IsCloud:this.props.IsCloud});              
            });

            var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
            if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
                this.setState({ LogOffTime : Number(E_LogoffTime) });
            }
    }

    componentDidMount() {
        if(this.props.getLabels["ActionsAndSettings.UAText.Text"] === undefined){
            this.props.getAllResources();
        }
        this.props.GetTenantWorkOrderLicenseInfo();
        this.props.GetLicenseCustomerInformation();
    }

    constructor(props) {
        super(props)
        this.state = {
            error_msg: false,
            IsLicensed: false,
            redirectBack: false,
            IsValidSerialNo: true,
            HasSerialNo: false,
            tooltipOpen: false,
            expirationtooltipOpen: false,
            offlinetooltipOpen: false,
            file_Name:'',
            enable_Upload:false,
            file:'',
            fileUrl:'',
            IsUpdate: false,
            IsViewPanel: false,
            Serialnumber:'',
            uploadSucceed: true,
            HasLicenseInfo: false,
            IsCloud: false,
            inactive_modal: false,
            LogOffTime: 1200000,
            HasFullAppPermission: true,
            IsCloudLicensed: false,
            UploadLicenseFileResponseData:{}
        }
        this.BackToActionSettings = this.BackToActionSettings.bind(this);
        this.OnGenerateServerID = this.OnGenerateServerID.bind(this);
        this.LoadToolTip = this.LoadToolTip.bind(this);
        this.ExpirLoadToolTip = this.ExpirLoadToolTip.bind(this);
        this.LoadOfflineToolTip = this.LoadOfflineToolTip.bind(this);
        this.toggle = this.toggle.bind(this);
        this.Expirtoggle = this.Expirtoggle.bind(this);
        this.offlinetoggle = this.offlinetoggle.bind(this);
        this.HandleFileUpload = this.HandleFileUpload.bind(this);
        this.updateLicense = this.updateLicense.bind(this);
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
        this.updateCloudLicenseCache = this.updateCloudLicenseCache.bind(this);
    }
    
    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.Inactivetoggle();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            if (nextProps.License_Information != null && nextProps.License_Information.length > 0) {
                this.setState({ IsCloudLicensed: true });
                if (nextProps.License_Customer_Information != null && nextProps.License_Customer_Information.length > 0) {
                    this.setState({
                        IsLicensed: true,
                        Serialnumber: nextProps.License_Customer_Information[nextProps.License_Customer_Information.length - 1].licenseCode
                    });
                    this.props.GetServerID(nextProps.License_Customer_Information[nextProps.License_Customer_Information.length - 1].licenseCode);
                }
            }
        }
    }

    BackToActionSettings() {
        if (this.state.IsUpdate) {
            this.setState({
                enable_Upload:  false,
                IsLicensed : true,
                uploadSucceed : true,
                file_Name: '',
                IsUpdate: false
            });
        }
        else {
            this.setState({ redirectBack: true })
        }
    }

    LoadToolTip(){
        this.setState({tooltipOpen:true});
    }

    ExpirLoadToolTip(){
        this.setState({expirationtooltipOpen:true});
    }

    LoadOfflineToolTip(){
        this.setState({offlinetooltipOpen:true});
    }

    toggle(){
        this.setState({tooltipOpen:false});
    }

    Expirtoggle(){
        this.setState({expirationtooltipOpen:false});
    }

    offlinetoggle(){
        this.setState({offlinetooltipOpen:false});
    }

    OnGenerateServerID(){
        this.setState({IsValidSerialNo: true});
        let SerialNumber = this.refs.ref_txtSerialNumber.value;
        let SerialFormat = new RegExp("^(([e]\\d\\d[a-z]\\d{5})|(0))$","i"); //"(?i)^(([e]\d\d[a-z]\d{5})|(0))$";
        if(!SerialFormat.test(SerialNumber)){
            this.setState({IsValidSerialNo: false});
        }else{
            var data = {
                "CustomerCode": SerialNumber,
                "LicenseUploaded": 0
            }
            
            const actionResponse = this.props.SaveLicenseRequest(data);
            actionResponse.then((result) => {
                this.setState({
                    HasSerialNo:true,
                    Serialnumber: SerialNumber
                });
            })
            
        }
    }

    _handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file_Name: file.name,
                enable_Upload : true,
                file: file,
                fileUrl: reader.result
            },()=>{
                const data = new FormData();
                data.append('file', file);
            });
        }
        if (file != undefined) {
            reader.readAsDataURL(file)
        }
        else{
            this.setState({
                file_Name: '',
                enable_Upload : true,
                file: file,
                fileUrl: ''
            });
        }
    }

    HandleFileUpload() {
        if (((this.state.file == undefined || this.state.file == null) || (this.state.file != null && this.state.file_Name != '' && (!String.prototype.endsWith ? this.state.file_Name.toUpperCase().indexOf(".LIC") < 0  : !this.state.file_Name.toUpperCase().endsWith(".LIC"))) || this.state.file.size == 0 || this.state.file.size > 1048576)) {
            this.setState({
                enable_Upload: false
            });
        }
      

        else {
        const  l_data  =  new  FormData();
        l_data.append('file',  this.state.file);
        const actionResponse = this.props.UploadLicenseFile(this.state.Serialnumber, l_data);
            actionResponse.then((result) => {
                this.props.GetLicenseInformation();
                this.props.GetTenantWorkOrderLicenseInfo();
                this.setState({
                    enable_Upload:  false,
                    IsLicensed : this.props.UploadStatus,
                    uploadSucceed : this.props.UploadStatus,
                    UploadLicenseFileResponseData : this.props.UploadLicenseFileResponse,
                    file_Name: '',
                    file: this.props.UploadStatus ? this.state.file : null,
                    IsUpdate: this.props.UploadStatus ? false : true
                });
            })
        }
    } 

    updateLicense()
    {
        this.setState({
            IsUpdate : true,
            HasSerialNo : true
        });       
    }
    
    RedirectToViewPanel = (isView) => {
        this.setState({IsViewPanel:isView});
    }

    OnPremiseRedirectToActionSettings = () => {
        var url = window.location.href.slice(0,window.location.href.indexOf('React'));
        url = url + "SystemAdmin/Administration.aspx";
        window.location.href = encodeURI(url)
    }

    updateCloudLicenseCache() {
        this.props.UpdateCloudLicenseCache();
    }

    render(ServerID, License_Information, Feature_License_Information,getLabels,getLicenseinfo) {
        let error_Message, Title ="Licensing", divManageLicense = "", UAText="", button_Text="Action and Settings";
        let LicenceType ="",LicenceEndDate="", HasWorkOrderLicense="Feature not licensed", HasDashBoardLicense="Feature not licensed", HasTenantLicense="Feature not licensed", HasCriticalControlLicense="Feature not licensed", HasSAMLLicense="Feature not licensed", HasAIAssistantLicense="Feature not licensed", ActiveLicense="";
        var l_LicenseFileSizeInByte = 1048576;
        let label = this.props.getLabels;
        let license_info = this.props.getLicenseinfo; 
        let IsOnPremises = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        Title = IsOnPremises ? label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] !== undefined ? label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] : 'Tracer Ensemble Licensing' : 'Licensing';

        if(this.state.redirectBack){
            return <Redirect to={"/SystemAdmin/Administration"} />
        }
        if(!this.state.IsValidSerialNo){
            error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
                            {label['RegisterTESSiteLicense.lblErrorSerialNumber.Text'] !== undefined ? label['RegisterTESSiteLicense.lblErrorSerialNumber.Text'] : "Error: You left necessary fields blank or entered invalid values. Review and correct any fields with ! next to them."} 
                            </p><br/></div>
        }

        if(this.props.ServerID != undefined && this.props.ServerID != ""){
            ServerID = this.props.ServerID;
        }
        if(((this.state.file == undefined || this.state.file == null) || ( this.state.file_Name != '' && (!String.prototype.endsWith ? this.state.file_Name.toUpperCase().indexOf(".LIC") < 0  : !this.state.file_Name.toUpperCase().endsWith(".LIC"))) || this.state.file.size == 0 || this.state.file.size > l_LicenseFileSizeInByte) && this.state.enable_Upload == false){
            let errorCode = this.state.UploadLicenseFileResponseData.errorState;
            if(errorCode === 1 ){
                error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
                {label['RegisterTESSiteLicense.LicenseError1.Text'] !== undefined ? label['RegisterTESSiteLicense.LicenseError1.Text'] : "The license file is not found."} 
                </p><br/></div> 
            }else if(errorCode === 3){
                error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
                {label['RegisterTESSiteLicense.LicenseError3.Text'] !== undefined ? label['RegisterTESSiteLicense.LicenseError3.Text'] : "The license file you attempted to use is invalid."} 
                </p><br/></div> 
            }else if(errorCode === 6){
                error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
                {label['RegisterTESSiteLicense.LicenseError6.Text'] !== undefined ? label['RegisterTESSiteLicense.LicenseError6.Text'] : "The license file you attempted to use has invalid host Id."} 
                </p><br/></div> 
            }
            else if(errorCode === 7 ){
                error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
                {label['RegisterTESSiteLicense.LicenseError7.Text'] !== undefined ? `${label['RegisterTESSiteLicense.LicenseError7.Text']} ${this.state.UploadLicenseFileResponseData.licenseEndDate}.` : `The license file you attempted to use expired on ${this.state.UploadLicenseFileResponseData.licenseEndDate}.`} 
                </p><br/></div> 
            }else{ 
                error_Message = <div><p style={{"padding-left":"10px"}} className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> 
{label['RegisterTESSiteLicense.UploadLicenseError1.Text'] !== undefined ? label['RegisterTESSiteLicense.UploadLicenseError1.Text'] : "The file that you attempted to upload does not have the expected license file format."} 
</p><br/></div>
            }
        }

        let BtnText = IsOnPremises ? (label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] !== undefined ? label['ActionsAndSettings.System.TracerEnsembleLicensingLink.Text'] : "Tracer Ensemble Licensing") : "Licensing";
        button_Text = this.state.IsUpdate ? BtnText : "Action and Settings";

        //View License Part Start
        if (this.props.License_Information != undefined && this.props.License_Information != null && this.props.License_Information.length > 0) {
            if (this.props.License_Information[0].productType != undefined) {
                if (this.props.License_Information[0].productType === "Full")
                    LicenceType = IsOnPremises ? "Full Tracer Ensemble" : "Full";
                else if (this.props.License_Information[0].productType === "Hosted")
                    LicenceType = IsOnPremises ? "Hosted Tracer Ensemble" : "Hosted";
                else if (this.props.License_Information[0].productType === "Express")
                    LicenceType = "Tracer Ensemble Express";
                else
                    LicenceType = this.props.License_Information[0].productType;
            }
            if (this.props.License_Information[0].endDate != undefined)
                LicenceEndDate = this.props.License_Information[0].endDate;
            if(this.props.License_Information[0].activeLicenses != undefined)
                ActiveLicense = this.props.License_Information[0].activeLicenses;
            if(license_info !== undefined && license_info !== ""){
                let  licensed_features = null;
                let   NoofTenant = 0;
                try{
                    licensed_features = license_info.licensedFeatures;
                    NoofTenant = (licensed_features !== undefined && licensed_features !== null && licensed_features.length) ? licensed_features[0].count : "";
                }
                catch(e){
                    console.log(e);
                }
                if(licensed_features !== undefined && licensed_features !== null){
                    HasWorkOrderLicense = licensed_features[1] != null ? licensed_features[1].licensed === true ? "Licensed" : "Feature not licensed" : "Feature not licensed";
                    HasDashBoardLicense = licensed_features[2] != null ? licensed_features[2].licensed === true ? "Licensed" : "Feature not licensed" : "Feature not licensed";
                    HasTenantLicense = licensed_features[0] != null ? licensed_features[0].licensed === true ? "Licensed for " + NoofTenant + " Tenants" : "Feature not licensed" : "Feature not licensed";
                    HasCriticalControlLicense = licensed_features[3] != null ? licensed_features[3].licensed === true ? "Licensed" : "Feature not licensed" : "Feature not licensed";
                    HasSAMLLicense = licensed_features[4] != null ? licensed_features[4].licensed === true ? "Licensed" : "Feature not licensed" : "Feature not licensed";
                    HasAIAssistantLicense = licensed_features[5] != null ? licensed_features[5].licensed === true ? "Licensed" : "Feature not licensed" : "Feature not licensed";
                }
            }
        }
        //View License Part End
        if((this.state.IsLicensed && !this.state.IsUpdate && this.state.uploadSucceed) || (this.state.IsCloud && this.state.IsCloudLicensed)){
            divManageLicense = <div className={IsOnPremises ? "ensemble_license_main_container": "main_container dbd_main_container_license"}>
                { IsOnPremises ?  
                    <Button type="button" id="viewDevices" className="btn btn-sm license_button" style={IsOnPremises ? {width: '185px', marginRight: '8px', padding: '0px'}:{}} onClick={() => this.RedirectToViewPanel(true)}>{label['RegisterTESSiteLicense.btnViewDeviceLicensing.Text'] !== undefined ? label['RegisterTESSiteLicense.btnViewDeviceLicensing.Text'] : "View Device Licensing"}</Button>
                  : ""
                } 
                {
                    this.state.IsCloud ? <Button type="button" id="btnUpdateLicensingCache" className="btn btn-sm license_button" onClick={this.updateCloudLicenseCache} style={IsOnPremises ? {width: '250px', padding: '0px'}:{}}>{label['RegisterTESSiteLicense.btnUpdateTracerEnsembleLicense.Text'] !== undefined ? label['RegisterTESSiteLicense.btnUpdateTracerEnsembleLicense.Text'] : "Update Tracer Ensemble License"}</Button>
                    : ""
                }
                <Button type="button" id="btnUpdateLicensing" className="btn btn-sm license_button" hidden = {IsOnPremises && this.state.IsCloud} onClick={this.updateLicense} style={IsOnPremises ? {width: '250px', padding: '0px'}:{}}>{IsOnPremises ? (label['RegisterTESSiteLicense.btnUpdateTracerEnsembleLicense.Text'] !== undefined ? label['RegisterTESSiteLicense.btnUpdateTracerEnsembleLicense.Text'] : "Update Tracer Ensemble License") : "Update License"}</Button>
                {IsOnPremises ?  <div className="LineSpace"/> : <div className="clear"/>}
                <div id="pnlLicenseInfo">
                    <legend id="lblLicenseInformation" className={IsOnPremises ? "EnsembleCustomContentHeading ContentMargin" : "PageTitleBar"}>{label['RegisterTESSiteLicense.LicenseInfo.Title.Text'] !== undefined ? label['RegisterTESSiteLicense.LicenseInfo.Title.Text'] : "License Information"}</legend>
                    <div  className='divWrapper'>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"}>{label['ViewLicenseInfo.lblLicenseType.Text'] !== undefined ? label['ViewLicenseInfo.lblLicenseType.Text'] : "License Type"}</span>
                        </div>
                        <Label id="lblLicenseTypeValue" className="ContentTextNoFloat">{LicenceType}</Label>
                    </div>
                    <div  className='divWrapper' style={{marginBottom: IsOnPremises ?'':'40px'}} hidden={this.state.IsCloud}>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"} style={{ "display": "inline-block" }}>{label['ViewLicenseInfo.lblLicenseEndDate.Text'] !== undefined ? label['ViewLicenseInfo.lblLicenseEndDate.Text'] : "Software Maintenance Plan Expiration Date"}</span>
                        </div>
                        <div>
                            <table><tr>
                                <td>
                                    <Label id="lblLicenseEndDateValue" className="ContentTextNoFloat">{LicenceEndDate}</Label>
                                </td>
                                <td style={{ "padding-left": "13px" }}>
                                    <div id="ExpirationCopyTooltip" onClick={() => { this.ExpirLoadToolTip() }} style={{ color: '#6890C6' }} className="link_cursor">{label['RegisterTESSiteLicense.WhatIsThis.Text'] !== undefined ? label['RegisterTESSiteLicense.WhatIsThis.Text'] : "What is this?"}</div>
                                    <Tooltip placement="right" isOpen={this.state.expirationtooltipOpen} target="ExpirationCopyTooltip" toggle={this.Expirtoggle} style={{maxWidth:'none'}}>
                                        After the Software Maintenance Plan expires, you will be able to use the currently installed version, upgrade to versions that were released prior to the expiration date, and install service packs for those versions.<br /><br /> You will not be able to upgrade to versions released after the expiration date unless you renew your Software Maintenance Plan.
                                    </Tooltip>
                                </td>
                            </tr></table>
                        </div>
                    </div>
                    { IsOnPremises ? 
                        <div  className='divWrapper' style={{marginBottom: '40px'}}>
                            <div className="labelWrapper">
                                <span className={"ContentLabel_OnPremise"}>{label['ViewPanelLicensing.lblLicenseUsed.Text'] !== undefined ? label['ViewPanelLicensing.lblLicenseUsed.Text'] : "Active Licenses"}</span>
                            </div>
                            <Label id="lblLicenseUsedValue" className="ContentTextNoFloat">{ActiveLicense}</Label>
                        </div> : <></>
                    }
                    <legend className={IsOnPremises ? "EnsembleCustomContentHeading ContentMargin" :"form_sub_title"}>{label['RegisterTESSiteLicense.lblLicenseFeatures.Text'] !== undefined ? label['RegisterTESSiteLicense.lblLicenseFeatures.Text'] : "Licensable Add-on Features"}</legend>
                    {IsOnPremises ? <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className="ContentLabel_OnPremise">{label['RegisterTESSiteLicense.CriticalControl.Text'] !== undefined ? label['RegisterTESSiteLicense.CriticalControl.Text'] : "Critical Control"}</span>
                        </div>
                        <Label id="lblLicenseFeaturesValueCritcalControl" className="ContentTextNoFloat">{HasCriticalControlLicense}</Label>
                    </div> : ''}
                    <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"}>{label['RegisterTESSiteLicense.DashBoard.Text'] !== undefined ? label['RegisterTESSiteLicense.DashBoard.Text'] : "DashBoard"}</span>
                        </div>
                        <Label id="lblLicenseFeaturesValueDashboard" className="ContentTextNoFloat">{HasDashBoardLicense}</Label>
                    </div>
                    <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"}>{label['EditPreferences.CustomHomepage.Tenant.Text'] !== undefined ? label['EditPreferences.CustomHomepage.Tenant.Text'] : "Tenant"}</span>
                        </div>
                        <Label id="lblLicenseFeaturesValueTenant" className="ContentTextNoFloat">{HasTenantLicense}</Label>
                    </div>
                    <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"}>{label['RegisterTESSiteLicense.WorkOrder.Text'] !== undefined ? label['RegisterTESSiteLicense.WorkOrder.Text'] : "Work Order"}</span>
                        </div>
                        <Label id="lblLicenseFeatureValueWorkOrder" className="ContentTextNoFloat">{HasWorkOrderLicense}</Label>
                    </div>
                    {IsOnPremises ? <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className="ContentLabel_OnPremise">{label['RegisterTESSiteLicense.lblLicenseFeaturesSAMLSSO.Text'] !== undefined ? label['RegisterTESSiteLicense.lblLicenseFeaturesSAMLSSO.Text'] : "SAML 2.0 SSO"}</span>
                        </div>
                        <Label id="lblLicenseFeatureValueSAMLSSO" className="ContentTextNoFloat">{HasSAMLLicense}</Label>
                    </div> : ''}
                    <div className='divWrapper'>
                        <div className="labelWrapper">
                            <span className={IsOnPremises ? "ContentLabel_OnPremise" : "ContentLabel"}>{label['RegisterTESSiteLicense.AIAssistant.Text'] !== undefined ? label['RegisterTESSiteLicense.AIAssistant.Text'] : "AI Assistant"}</span>
                        </div>
                        <Label id="lblLicenseFeatureValueAIAssistant" className="ContentTextNoFloat">{HasAIAssistantLicense}</Label>
                    </div>
                </div>
            </div>
        }else{
            let l_Title = IsOnPremises ? (label['Administration.lblTracerEnsembleRegisterLicense.Text'] !== undefined ? label['Administration.lblTracerEnsembleRegisterLicense.Text'] : "Tracer Ensemble Licensing - Register License" ) : "Licensing - Register License";
            let l_UpdateTitle = IsOnPremises ? (label['UpdateLicensing.PageTitle.Text'] !== undefined ? label['UpdateLicensing.PageTitle.Text'] : "Update Tracer Ensemble License") : "Update License";
            Title = this.state.IsUpdate ?  l_UpdateTitle : l_Title;
            UAText = this.state.IsUpdate ? (label['UpdateLicensing.UserAssistAdmin.Text'] !== undefined ? label['UpdateLicensing.UserAssistAdmin.Text'] : "Enter the Server ID on the licensing site to create an updated license file. Upload the license file to this page.") : ( label['RegisterTESSiteLicense.lblUserAssistAdmin.Text'] !== undefined ? label['RegisterTESSiteLicense.lblUserAssistAdmin.Text'] : "This installation is not licensed. Enter the software serial number which Tracer Ensemble will use to create a server ID. Enter the server ID on the licensing site to create a license file. Upload the license file to this page.");

            if(!this.state.HasLicenseInfo){
                Title = "";
                divManageLicense = <div ><span className="ContentLabel">Loading....  </span></div>
            }else{
                //To handle cloud customer
                this.state.IsCloud ? divManageLicense = <div>
                    <p className="ContentTextNoFloat">We have identified an issue with your license. Contact your local Trane office for assistance</p>
                </div> :
            divManageLicense = <div className={IsOnPremises ? "" : "main_container dbd_main_container"}>
                <div style={{"min-height": "50px", "padding-top": "5px"}}>
                    <span id="lblUserAsstAdmin" style={{"width":"65%","display": "inline-block", "line-height":"15px"}} className="ContentTextNoFloat">{UAText}</span>
                </div>
                {error_Message}
                <div hidden={this.state.IsUpdate}>
                    <div id="pnlSerialNum" style={{"margin-top":"30px"}}>
                        <div className="labelWrapper">
                            <span id="lblSerialNum" className="ContentLabel">{label['RegisterTESSiteLicense.lblSerialNum.Text'] !== undefined ? label['RegisterTESSiteLicense.lblSerialNum.Text'] : "Software Serial Number"} </span>&nbsp;&nbsp;
                        </div>
                        <div style={{"display": "inline-block","padding-left":"35px"}}>
                            <span hidden={this.state.IsValidSerialNo}>!&nbsp;</span>
                            <input type="text" ref="ref_txtSerialNumber" id="txtBoxSerialNumber"/>
                        </div>&nbsp;&nbsp;
                        <Button type="button" id="btnGenerateServerId" style={{"margin-left":"7px"}} className="btn-black btn-md btn btn-secondary" onClick={this.OnGenerateServerID} >{label['RegisterTESSiteLicense.lblGenerateServerId.Text'] !== undefined ? label['RegisterTESSiteLicense.lblGenerateServerId.Text'] : "Generate Server ID"}</Button>
                    </div>
                </div>
            
                <div id="pnlServerIdandUpload" hidden={!this.state.IsValidSerialNo}>
                    <div hidden={!this.state.HasSerialNo} style={{"margin-bottom":"70px"}}>
                        <table><tr>
                            <td>
                                <span id="lblServerId" className="ContentLabel">{label['RegisterTESSiteLicense.lblServerId.Text'] !== undefined ? label['RegisterTESSiteLicense.lblServerId.Text'] : "Server ID"}</span>&nbsp;&nbsp;
                            </td>
                            <td>
                                <span id="lblServerIdValue" style={{ "padding-left": !this.state.IsUpdate ? "159px" : "132px" }} className="ContentTextNoFloat" >{ServerID}</span>
                            </td>
                            <td>
                                <CopyToClipboard text={ServerID}>
                                    <Button type="button" id="btnCopyServerId" className="btn-black btn-md btn btn-secondary" style={{"margin-left" : "7px"}}>{label['RegisterTESSiteLicense.lblCopy.Text'] !== undefined ? label['RegisterTESSiteLicense.lblCopy.Text'] : "Copy To Clipboard"}</Button>
                                </CopyToClipboard>
                            </td>
                            <td>
                                <div id="CopyTooltip" onClick={() => { this.LoadToolTip() }} className="dbd_EnsembleLink">{label['RegisterTESSiteLicense.Copy.Text'] !== undefined ? label['RegisterTESSiteLicense.Copy.Text'] : "What is Copy?"}</div>
                                <Tooltip style={{"height":"90px",maxWidth:'none'}} placement="right" isOpen={this.state.tooltipOpen} target="CopyTooltip" toggle={this.toggle}>
                                {
                                    label['RegisterTESSiteLicense.helpWhatIsCopy.Text'] !== undefined ? label['RegisterTESSiteLicense.helpWhatIsCopy.Text'] : 'Use this button to put the Server ID onto the Windows clipboard. Then you can use the "Ctrl" and the "V" keys simultaneously to paste the Server ID where your cursor is, such as into the licensing web site or into a text editor for later use.'
                                }
                                </Tooltip>
                            </td>
                        </tr></table>
                    </div>
                    <div hidden={!this.state.HasSerialNo}>    
                        <div>
                            <Label id="lblCreateLicenseHeading" className="ContentLabel" style={{"margin-bottom":"10px"}}>{label['RegisterTESSiteLicense.lblCreateLicenseHeading.Text'] !== undefined ? label['RegisterTESSiteLicense.lblCreateLicenseHeading.Text'] : "Use the Server ID to Create a License File"}</Label>
                        </div>
                        <div>
                            <span id="lblCreateLicenseUAText" style={{"width":"65%","display": "inline-block", "margin-bottom":"10px"}} className="ContentTextNoFloat">{label['RegisterTESSiteLicense.lblCreateLicenseUAText.Text']}</span>
                        </div>
                        <div style={{"margin-bottom":"80px", "padding-left":"10px"}}>
                            <Button type="button" id="btnGoToLicenseWebsite" className="btn-black btn-md btn btn-secondary" onClick={()=> window.open(Website, "_blank")}>{label['RegisterTESSiteLicense.lblGoToWebsite.Text'] !== undefined ? label['RegisterTESSiteLicense.lblGoToWebsite.Text'] : "Go to website"}</Button>
                            <span id="Offlinetip" onClick={() => { this.LoadOfflineToolTip() }} className="dbd_EnsembleLink">{label['RegisterTESSiteLicense.WhatIf.Text'] !== undefined ? label['RegisterTESSiteLicense.WhatIf.Text'] : "What if I'm offline?"}</span>
                            <Tooltip placement="right" isOpen={this.state.offlinetooltipOpen} target="Offlinetip" toggle={this.offlinetoggle} style={{maxWidth:'none'}}>
                                You must have internet access in order to go to the BASRegistration.trane.com web site.<br/><br/> If you do not have internet access at your current location, use the Copy to Clipboard button to capture the Server ID. Save Server ID and move to a location where you do have internet access. Then open a browser and go to the BASRegistration.trane.com to start creating a license file. When prompted, use the Server ID that you already saved.
                            </Tooltip>
                        </div>
                    </div>
                    <div hidden={!this.state.HasSerialNo}>    
                        <div>
                            <Label id="lblUploadLicenseFile" className="ContentLabel" style={{"margin-bottom":"10px"}}>{label['Administration.hlnkUploadLicenseFile.Text'] !== undefined ? label['Administration.hlnkUploadLicenseFile.Text'] : "Upload License File"}</Label>
                        </div>
                        <div style={{"margin-bottom":"20px"}}>
                            <div className='labelWrapper'>
                                <Label id="lblLicenseFile" className="ContentLabel">{label['Administration.lblLicenceFile.Text'] !== undefined ? label['Administration.lblLicenceFile.Text'] : "License File"}</Label>
                            </div>
                            <span id="lblFileName" className="ContentTextNoFloat">{this.state.file_Name !== "" ? this.state.file_Name : (label['RegisterTESSiteLicense.lblFileNameDefault.Text'] !== undefined ? label['RegisterTESSiteLicense.lblFileNameDefault.Text'] : "[No License File]")}</span>
                            <label className="custom-file-upload btn btn-black inv_btn" style={{"float": "none", "margin-left": "10px"}} >
                                <input type="file" onChange={(e) => this._handleImageChange(e)} />
                                <i id="btnFileBrowse" className="fa fa-cloud-upload"></i>{label['SystemAdminFileUpload.Browse.Text'] !== undefined ? label['SystemAdminFileUpload.Browse.Text'] : "Browse..."} 
                            </label>
                        </div>
                        <div style={{paddingLeft:'10px'}}>
                            <Button type="button" id="btnUploadLicenseFile" disabled={!this.state.enable_Upload} className="btn-black btn-md btn btn-secondary" onClick={this.HandleFileUpload} >Upload License File</Button>
                        </div>
                    </div>
                </div>
                </div>
            }
        }
        return (
            <div>
                 <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({
                            inactive_modal: true
                        });
                    }
                }} />
                { !this.state.HasFullAppPermission ? <UserNotAuthorized /> :
                this.state.IsViewPanel ? <ViewPanelLicensing IsOnPremises={IsOnPremises} BackToLicense={this.RedirectToViewPanel} /> :
                <><div className={IsOnPremises ? "" :"bldng_installation_titlebar"}>
                    <div className={ IsOnPremises ? "dbd_Ensemblesubheader" : "dbd_subheader"} style={{"padding-left": IsOnPremises ? "0px" : "27px"}}>
                        <span id="lblLicenseHeader" className="PageTitleBar">{Title}</span>
                    </div>
                </div>
                {divManageLicense}
                <FormGroup row className="btns_group" style={{"margin-top":"10%"}}>
                    <Col sm={{ size: 10 }} style={{"padding-left":IsOnPremises ? "25px" : "45px","paddingBottom": IsOnPremises ? "30px" : "0px"}}>
                        <Button id="btnBackToActionsAndSettings" className="btn-black btn-md" onClick={IsOnPremises && !this.state.IsUpdate ? () => this.OnPremiseRedirectToActionSettings() : this.BackToActionSettings} > {"<"} {button_Text} </Button>
                    </Col>
                </FormGroup></>
                }
                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={classnames({ classnames: this.props.className }, "ModalContainer InActive_Short_Modal")} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        ServerID: state.InstallationsRootReducer.ServerId,
        License_Information: state.InstallationsRootReducer.License,
        Feature_License_Information: state.InstallationsRootReducer.FeatureLicenseInformation,
        License_Customer_Information: state.InstallationsRootReducer.CustomerInformation,
        UploadStatus: state.InstallationsRootReducer.UploadStatus,
        UploadLicenseFileResponse:state.InstallationsRootReducer.UploadLicenseFileResponse,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
        getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense,
        OnPremises: state.authService.IsOnPremise,
        IsCloud: state.InstallationsRootReducer.IsCloud,
        ApplicationPermission: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SaveLicenseRequest: (data) => dispatch(SaveLicenseRequest(data)),
        UploadLicenseFile: (id,data) => dispatch(UploadLicenseFile(id,data)),
        GetLicenseInformation: () => dispatch(GetLicenseInformation()),
        GetLicenseCustomerInformation: () => dispatch(GetLicenseCustomerInformation()),
        GetServerID: (id) => dispatch(GetServerID(id)),
        getAllResources: () => dispatch(getAllResources()),
        getInstanceType: () => dispatch(getInstanceType()),
        GetTenantWorkOrderLicenseInfo: () => dispatch(GetTenantWorkOrderLicenseInfo()),
        AppRolePermission: (id, App) => dispatch(AppRolePermission(id, App)),
        UpdateCloudLicenseCache: () => dispatch(UpdateCloudLicenseCache())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageLicense);
  
